import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../ui/Icon'
import { useAppStore } from '../../store/useAppStore'
import { Button } from '../ui/Button'

interface FullScreenPreviewButtonProps {
  className?: string
}

export const FullScreenPreviewButton: React.FC<FullScreenPreviewButtonProps> = ({ className = '' }) => {
  const { t } = useTranslation()
  const setOpen = useAppStore(state => state.setFullScreenPreviewOpen)

  const handleClick = () => {
    setOpen(true)
  }

  return (
    <Button
      onClick={handleClick}
      variant="secondary"
      size="sm"
      className={`gap-2 whitespace-nowrap flex-shrink-0 ${className}`}
      aria-label={t('preview.fullScreen')}
      title={t('preview.fullScreen')}
    >
      <Icon name="maximize" size={16} />
      <span className="hidden sm:inline">{t('preview.fullScreen')}</span>
    </Button>
  )
}
